module.exports = __webpack_public_path__ + "static/media/logoBlueShield-CA.b115081c.png";